import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";
import NtSectionButton from "../general/NtSectionButton";
import colors from "../../../config/colors";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtMarketingDevider from "../general/NtMarketingDevider";
import { useMobile } from "../../../hooks/useMobile";

function NtPlansFeatureSection(props) {
  const isMobile = useMobile();

  const options = [
    {
      id: 0,
      title: "Free Worldwide Calls Inside our Network",
    },
    {
      id: 1,
      title: "No Free Calls to the U.S., Canada or Puerto Rico",
    },
    {
      id: 2,
      title:
        "Buy or (earn free)* TALK Credits to make International calls & texts",
    },
    {
      id: 3,
      title: "Low-Cost\nInternational Call Rates",
    },
    {
      id: 4,
      title: "No monthly minutes\n(for calls outside network)",
    },
    {
      id: 5,
      title: "No Call Blocking",
    },
    {
      id: 6,
      title: "No\nVoicemail",
    },
    {
      id: 7,
      title: "Self-Service\nTechnical Support",
    },
    {
      id: 8,
      title: "Low-Cost\nPrimary Phone Number\n(from U.S. or Canada)",
    },
    {
      id: 9,
      title: "Low-Cost\nSecondary Phone Number\n(from U.S. or Canada)",
    },
    {
      id: 10,
      title: "No\nNumber Porting",
    },
    {
      id: 11,
      title: "No\nCall Forwarding",
    },
    {
      id: 12,
      title: "Basic Spam Call Filter\n(identifies spam calls)",
    },
    {
      id: 13,
      title: "Spam Call Whitelist",
    },
    {
      id: 14,
      title: "No\nRoboAgent",
    },
    {
      id: 15,
      title: "No PIN Shield",
    },
    {
      id: 16,
      title: "No Conference Calling",
    },
    {
      id: 17,
      title: "No Enhanced 911 Service",
    },
    {
      id: 18,
      title: "Not Fax-Friendly",
    },
    {
      id: 19,
      title: "No Caller ID Blocking",
    },
    {
      id: 20,
      title: "No Call Waiting",
    },
    {
      id: 21,
      title: "No Incoming Caller ID Number",
    },
    {
      id: 22,
      title: "3-Way Calling",
    },
    {
      id: 23,
      title: "Speed Dial",
    },
    {
      id: 24,
      title: "Online Account Manager",
    },
    {
      id: 25,
      title: "No Contracts",
    },
  ];

  const appOptions = [
    {
      id: 0,
      enabled: true,
    },
    {
      id: 2,
      enabled: true,
    },
    {
      id: 3,
      enabled: true,
    },
    {
      id: 7,
      enabled: true,
    },
    {
      id: 8,
      enabled: true,
    },
    {
      id: 9,
      enabled: true,
    },
    {
      id: 10,
      enabled: true,
    },
    {
      id: 12,
      enabled: true,
    },
    {
      id: 22,
      enabled: true,
    },
    {
      id: 23,
      enabled: true,
    },
    {
      id: 24,
      enabled: true,
    },
    {
      id: 25,
      enabled: true,
    },
  ];

  const nextGenOptions = [
    {
      id: 0,
      enabled: true,
    },
    {
      id: 1,
      enabled: true,
    },
    {
      id: 2,
      enabled: true,
    },
    {
      id: 3,
      enabled: true,
    },
    {
      id: 4,
      enabled: true,
      title: "1,500** monthly minutes\n(for calls outside network)",
    },
    {
      id: 5,
      enabled: true,
      title: "Block 1 caller",
    },
    {
      id: 6,
      enabled: true,
      title: "Visual\nVoicemail",
    },

    {
      id: 7,
      enabled: true,
      title: "Live Online\nTechnical Support",
    },
    {
      id: 8,
      enabled: true,
      title: "Free\nPrimary Phone Number\n(from U.S. or Canada)",
    },
    {
      id: 9,
      enabled: true,
      title: "Low-Cost\nSecondary Phone Number\n(from U.S. or Canada)",
    },
    {
      id: 10,
      enabled: true,
      title: "Low-Cost\nNumber Porting",
    },
    {
      id: 11,
      enabled: true,
      title: "Call\nForwarding",
    },
    {
      id: 12,
      enabled: true,
    },
    {
      id: 13,
      enabled: true,
    },
    {
      id: 14,
      enabled: true,
      title: "Basic RoboAgent\n(bot answers spam calls)",
    },
    {
      id: 16,
      enabled: true,
    },
    {
      id: 17,
      enabled: true,
    },
    {
      id: 18,
      enabled: true,
    },
    {
      id: 19,
      enabled: true,
    },
    {
      id: 20,
      enabled: true,
    },
    {
      id: 21,
      enabled: true,
    },

    {
      id: 22,
      enabled: true,
    },
    {
      id: 23,
      enabled: true,
    },
    {
      id: 24,
      enabled: true,
    },
    {
      id: 25,
      enabled: true,
    },
  ];

  const vipOptions = [
    {
      id: 0,
      enabled: true,
    },
    {
      id: 1,
      enabled: true,
    },
    {
      id: 2,
      enabled: true,
    },
    {
      id: 3,
      enabled: true,
      title: "20% OFF\nInternational Call Rates",
    },
    {
      id: 4,
      enabled: true,
      title: "3,000** monthly minutes\n(for calls outside network)",
    },
    {
      id: 5,
      enabled: true,
      title: "Block 1000 callers",
    },
    {
      id: 6,
      enabled: true,
      title: "Visual Voicemail\nwith Transcripts",
    },

    {
      id: 7,
      enabled: true,
      title: '"Fast-Pass" Live Online\nTechnical Support ',
    },
    {
      id: 8,
      enabled: true,
      title: "Free \nPrimary Phone Number\n(from U.S. or Canada)",
    },
    {
      id: 9,
      enabled: true,
      title: "One Free\nSecondary Phone Number\nComming Soon",
    },
    {
      id: 10,
      enabled: true,
      title: "One Free Number Port\nComing Soon",
    },
    {
      id: 11,
      enabled: true,
      title: "Advanced Call Forwarding\nComing Soon",
    },
    {
      id: 12,
      enabled: true,
      title: "Customizable Spam Call Filter\nComing Soon",
    },
    {
      id: 13,
      enabled: true,
    },
    {
      id: 14,
      enabled: true,
      title: "Customizable\nRoboAgent",
    },
    {
      id: 15,
      enabled: true,
      title: "Pin Shield",
    },
    {
      id: 16,
      enabled: true,
    },
    {
      id: 17,
      enabled: true,
    },
    {
      id: 18,
      enabled: true,
    },
    {
      id: 19,
      enabled: true,
    },
    {
      id: 20,
      enabled: true,
    },
    {
      id: 21,
      enabled: true,
    },

    {
      id: 22,
      enabled: true,
    },
    {
      id: 23,
      enabled: true,
    },
    {
      id: 24,
      enabled: true,
    },
    {
      id: 25,
      enabled: true,
    },
  ];

  const renderBox = (
    containerStyle,
    image,
    title,
    renderMessage,
    renderPrice,
    fee,
    enabledFeatures,
    footer
  ) => {
    return (
      <View
        style={[
          {
            flex: 1,
            borderRadius: 10,
            backgroundColor: "#181818",
          },
          containerStyle,
        ]}
      >
        <View style={{ padding: 15 }}>
          <Image
            style={[
              {
                width: 35,
                height: 35,
                resizeMode: "contain",
              },
            ]}
            source={image}
          />
          <NtSectionDescription
            style={{ marginTop: 10, fontSize: 12, fontWeight: "800" }}
          >
            {title}
          </NtSectionDescription>

          <View style={{ marginTop: 10 }}>{renderMessage}</View>

          <View style={{ marginTop: 20 }}>{renderPrice}</View>
          <NtSectionDescription
            style={{ marginTop: 6, fontSize: 12, fontWeight: "200" }}
          >
            {fee}
          </NtSectionDescription>

          <NtSectionButton
            containerStyle={{ marginTop: 20 }}
            title="Sign Up"
            color={colors.lighGray}
            onPress={() => {
              window.open("https://account.ntconnect.com/site/login");
            }}
          />
        </View>

        <NtMarketingDevider containerStyle={{ marginTop: 15 }} />

        <View style={{ flex: 1 }}>
          {options.map((each) => renderRow(each, enabledFeatures))}
        </View>

        <NtSectionTitle
          style={{
            marginTop: 40,
            fontSize: 14,
            marginRight: 10,
            marginLeft: 10,
            paddingLeft: 15,
            paddingRight: 15,
            height: 80,
          }}
        >
          {footer}
        </NtSectionTitle>

        <NtSectionButton
          containerStyle={{
            marginLeft: 15,
            marginRight: 15,
            marginBottom: 30,
          }}
          title="Sign Up"
          color="white"
          onPress={() => {
            window.open("https://account.ntconnect.com/site/login");
          }}
        />
      </View>
    );
  };

  const renderRow = (item, options) => {
    const option = options?.find((each) => each.id == item.id);

    return (
      <View key={item.title}>
        <View
          style={{ padding: 15, flexDirection: "row", alignItems: "center" }}
        >
          <NtSectionDescription
            style={{
              fontSize: 12,
              fontWeight: "300",
              flex: 1,
              marginRight: 10,
            }}
          >
            {option?.title || item.title}
          </NtSectionDescription>
          <NtMaterialIcon
            name={option?.enabled == true ? "check-bold" : "circle-off-outline"}
            color={option?.enabled == true ? "green" : "red"}
            size={15}
          />
        </View>
        <NtMarketingDevider />
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle>CALL PLAN FEATURES</NtSectionTitle>

      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          marginTop: 30,
        }}
      >
        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          require("../../../assets/images/marketing/7a84a4ee50548b8859c50d8ce5f6ffb223aa37fd.png"),
          "TALK App",
          <NtSectionDescription style={{ fontSize: 11, fontWeight: "200" }}>
            <NtText style={{ fontWeight: "500" }}>
              Free internation phone
            </NtText>
            {"\n"}for iOS and Android mobile devices
          </NtSectionDescription>,
          <NtSectionDescription style={{ fontSize: 18, fontWeight: "800" }}>
            Free
          </NtSectionDescription>,
          "No annual fee",
          appOptions,
          "BUY THE VIP ADD-ON WHEN YOU SIGN UP FOR NEXGEN"
        )}

        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          require("../../../assets/images/marketing/3b4f36bda92f49f5fa9fb42da1a9776f3373981e.png"),
          "NexGen",
          <NtSectionDescription style={{ fontSize: 11, fontWeight: "200" }}>
            Our next-generation VoIP phone service{"\n"}
            <NtText style={{ fontWeight: "500" }}>
              Bring Your Own Device.
            </NtText>
          </NtSectionDescription>,
          <NtSectionDescription style={{ fontSize: 18, fontWeight: "800" }}>
            $9
            <NtText style={{ fontSize: 11, fontWeight: "400" }}>
              {" "}
              / month
            </NtText>
          </NtSectionDescription>,
          "No annual fee",
          nextGenOptions,
          "CREATE THE NT CONNECT ACCOUNT & UPGRADE TO NEXGEN"
        )}

        {renderBox(
          {},
          require("../../../assets/images/marketing/92a04135c53927021cda6b1b1d43df25a7a0d610.png"),
          "NexGen VIP",
          <NtSectionDescription style={{ fontSize: 11, fontWeight: "200" }}>
            <NtText style={{ fontWeight: "500" }}>NexGen + VIP Add-On</NtText>
            {"\n"}Upgrade your experience.
          </NtSectionDescription>,
          <NtSectionDescription style={{ fontSize: 18, fontWeight: "800" }}>
            $9
            <NtText style={{ fontSize: 11, fontWeight: "400" }}>
              {" "}
              / month
            </NtText>
          </NtSectionDescription>,
          "Plus $40 annual fee",
          vipOptions,
          "BUY THE VIP ADD-ON WHEN YOU SIGN UP FOR NEXTGEN"
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtPlansFeatureSection;
